var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.73074C0 2.19067 2.13505 0.128906 4.76695 0.128906H59.733C62.366 0.128906 64.5 2.19067 64.5 4.73074V59.7698C64.5 62.3106 62.366 64.3709 59.733 64.3709H4.76695C2.1353 64.3709 0 62.3109 0 59.7706V4.72999V4.73074Z",
    fill: "#8AD9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6009 53.8908V24.9689H9.94904V53.8908H19.6019H19.6009ZM14.777 21.0208C18.142 21.0208 20.237 18.7999 20.237 16.0244C20.1741 13.1857 18.142 11.0269 14.841 11.0269C11.5376 11.0269 9.38013 13.1857 9.38013 16.0242C9.38013 18.7996 11.4744 21.0205 14.7137 21.0205H14.7762L14.777 21.0208ZM24.9433 53.8908H34.5943V37.7412C34.5943 36.878 34.6573 36.0125 34.9123 35.3959C35.6097 33.6681 37.1978 31.8797 39.8647 31.8797C43.3563 31.8797 44.7538 34.5316 44.7538 38.42V53.8908H54.4047V37.3079C54.4047 28.4246 49.6437 24.2908 43.2938 24.2908C38.0877 24.2908 35.8012 27.189 34.5308 29.1629H34.5951V24.9699H24.9438C25.0698 27.6831 24.943 53.8918 24.943 53.8918L24.9433 53.8908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 64.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.4af4ca36fb97797f743eae8052f5d40d.svg";
export { ForwardRef as ReactComponent };